<template>
  <v-form v-model="valid" @submit.prevent="login">
    <v-container>
      <v-row v-if="errorMessage != ''">
        <v-col>
          <v-alert icon="mdi-alert-circle" type="error">
            {{ errorMessage }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="userName"
            :rules="userNameRules"
            label="ユーザー名"
            outlined
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            type="password"
            label="パスワード"
            outlined
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn block :loading="loading" color="error" @click="login">
            サインイン
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import axios from 'axios'
import repository from '@/store/repository'
import handleApiError from '@/plugins/handleApiError'

export default {
  data: () => ({
    valid: false,
    userName: '',
    password: '',
    loading: false,
    userNameRules: [(v) => !!v || 'ユーザー名は必須項目です'],
    passwordRules: [(v) => !!v || 'パスワードは必須項目です'],
    errorMessage: ''
  }),
  methods: {
    async correspondUid (result) {
      const reqUrl = process.env.VUE_APP_COGNITO_USER_ID_GET_API_URL
      const reqBody = {
        corpUserId: result.accessToken.payload.username,
        authTime: result.accessToken.payload.auth_time,
        cognitoIdToken: result.idToken.jwtToken
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_COGNITO_USER_ID_GET_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)

      this.$store.commit('setLoginUser', res.data[0])
      this.$store.commit('setUser', res.data[0])
      repository.setPjmUserId(res.data[0].pjmUserId)
    },

    async sendLog (result) {
      const reqUrl = process.env.VUE_APP_COGNITO_DB_USERLOG_API_URL
      const reqBody = {
        OperationType: 'PUT',
        Keys: {
          userId: result.accessToken.payload.username,
          accessToken: result.accessToken.jwtToken,
          loginAt: result.accessToken.payload.auth_time
        }
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_COGNITO_DB_USERLOG_API_KEY,
          Authorization: repository.getAccessToken()
        }
      }

      axios.post(reqUrl, reqBody, header)
    },

    handleLoginError (err) {
      switch (err.code) {
        case 'NotAuthorizedException':
          this.errorMessage = 'ユーザ名またはパスワードが間違っています'
          break
        default:
          this.errorMessage = 'サインインできませんでした'
      }
      this.loading = false
    },

    async login () {
      if (!this.valid) return
      this.loading = true

      const res = await this.$cognito
        .login(this.userName, this.password).catch(this.handleLoginError)

      repository.setIdToken(res.idToken.jwtToken)
      repository.setAccessToken(res.accessToken.jwtToken)
      this.$store.commit('setIdToken', res.idToken.jwtToken)
      this.$store.commit('setAccessToken', res.accessToken.jwtToken)
      this.$store.commit('setUserName', res.accessToken.payload.username)
      this.sendLog(res)
      await this.correspondUid(res).catch(this.handleLoginError)

      this.loading = false
      this.$emit('success')
    }
  }
}
</script>
